import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import { OnboardingFormProps } from '../../components/forms/OnboardingForm'

import * as SC from './styled'

export type OnboardingTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  onboardingForm: OnboardingFormProps
}

const OnboardingTemplate: FC<OnboardingTemplateProps> = (props) => {
  const { layout, onboardingForm } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.Form {...onboardingForm} />
      </SC.Content>
    </DefaultLayout>
  )
}

export default OnboardingTemplate
